export const NewQueryCategoryButton = ({
  title,
  description,
  note,
  onClick,
}: {
  title: string;
  description: string;
  note?: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    className="flex flex-col gap-y-0.5 rounded-lg border border-lightGray px-4 py-3 text-left transition-colors hover:border-primary-100 hover:bg-primary-150"
    onClick={onClick}
  >
    <span className="text-300 font-bold text-black-100">{title}</span>
    <span className="text-200 text-black-54">{description}</span>
    {note && <span className="mt-1 text-90 text-black-32">{note}</span>}
  </button>
);
